"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EligibilityCriteria = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../../../copy");
var mapReasonCodeToMapKey = function (reasonCode) {
    if (reasonCode === 'NoDirectDebitError' ||
        reasonCode === 'NO_ACTIVE_MANDATE') {
        return 'NO_ACTIVE_MANDATE';
    }
    if (reasonCode === 'BalanceWouldNotExceedDirectDebitError') {
        return 'BALANCE_WOULD_NOT_EXCEED_DIRECT_DEBIT';
    }
    if (reasonCode === 'IsLossCustomerError' ||
        reasonCode === 'ACCOUNT_IN_LOSS') {
        return 'ACCOUNT_IN_LOSS';
    }
    if (reasonCode === 'StaleMeterReadingError' ||
        reasonCode === 'NO_FRESH_METER_READING') {
        return 'NO_FRESH_METER_READING';
    }
    return '';
};
var EligibilityCriteria = function (_a) {
    var reasonCode = _a.reasonCode;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var _b = (0, core_1.useComponents)(), Ul = _b.Ul, Li = _b.Li, Heading4 = _b.Heading4;
    if (reasonCode === 'RefundAlreadyRequestedError' ||
        reasonCode === 'PAYOUT_ALREADY_REQUESTED') {
        return null;
    }
    var reasonCodes = new Map([
        ['NO_ACTIVE_MANDATE', 'ineligibleReasonDDSetupLink'],
        ['BALANCE_WOULD_NOT_EXCEED_DIRECT_DEBIT', 'ineligibleReasonOneDD'],
        ['ACCOUNT_IN_LOSS', 'ineligibleReasonInLoss'],
        ['NO_FRESH_METER_READING', 'ineligibleReasonFreshReads'],
    ]);
    // if the reasonCode is in the map, it'll be removed and displayed separately in which case the heading needs to read
    // that you *also* need to fulfill the other requirements (look at the copy strings for clarity).
    // TODO: this needs refactoring
    var reasonCodeMapKey = mapReasonCodeToMapKey(reasonCode);
    var heading = reasonCodes.has(reasonCodeMapKey) ? (react_1.default.createElement(Copy, { copyKey: "ineligibleHeadingLong" })) : (react_1.default.createElement(Copy, { copyKey: "ineligibleHeadingShort" }));
    reasonCodes.delete(reasonCodeMapKey);
    if (reasonCode === 'IsLossCustomerError' ||
        reasonCode === 'ACCOUNT_IN_LOSS') {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Heading4, { as: "h2" },
                react_1.default.createElement(Copy, { copyKey: "eligibleWhenHeading" })),
            react_1.default.createElement(Copy, { copyKey: "eligibleWhenBody" })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Heading4, { as: "h2" }, heading),
        react_1.default.createElement(Ul, null, Array.from(reasonCodes.values()).map(function (reason, index) { return (react_1.default.createElement(Li, { key: index },
            react_1.default.createElement(Copy, { copyKey: reason }))); }))));
};
exports.EligibilityCriteria = EligibilityCriteria;
